module.exports = __webpack_public_path__ + "static/media/created.5ba6ad59.svg";